module.exports = __webpack_public_path__ + "static/curate-products-mobile-8ea14dbee1c91fc29bbeb04db3e854af.png";